import React from "react";

const CloseIcon = () => {
  return (
    <div className="drawer_app_close_icon">
      <span className="drawer_app_close_icon_line drawer_app_close_icon_line1"></span>
      <span className="drawer_app_close_icon_line drawer_app_close_icon_line2"></span>
    </div>
  );
};

export default CloseIcon;
